export const SELECTED_DISTRIBUTOR="SELECTED_DISTRIBUTOR"